export default __webpack_public_path__ + "static/media/preview_platform_tour.8afba974.png";